import { useQuery } from "@tanstack/react-query";
import { fetchSchemeClassificationTree } from "../components/NMPForm/nmpClassificationTree.api";

export const useNMPClassificationTree = (
	schemeId: number | string | null | undefined,
) => {
	const query = useQuery({
		queryKey: ["nmp-classification-tree", schemeId],
		queryFn: () => fetchSchemeClassificationTree(schemeId as number | string),
		enabled: !!schemeId,
	});

	return {
		...query,
		classifications: query.data?.classifications ?? [],
	};
};
